import src from "IMAGE";
export default { src, width: 1024, height: 168, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AK+vsGqysrJvnp6fUKSkpFWmp6dfrKytZ6ysrGW1tbVmPTwTF0snxBYAAAAASUVORK5CYII="};
